export const isValidBrowser = (browserString: string): boolean => {
  const browserRegexes = [
    /MSIE|Trident/i, // Internet Explorer
    /Edge|Edg/i, // Microsoft Edge (legacy and Chromium-based)
    /Firefox/i, // Mozilla Firefox
    /OPR|Opera|Opera Mini/i, // Opera browsers (desktop and mini)
    /Chrome/i, // Google Chrome
    /Chromium/i, // Chromium-based browsers
    /Safari/i, // Apple Safari and others using WebKit
    /Brave/i, // Brave browser
    /Vivaldi/i, // Vivaldi browser
    /SamsungBrowser/i, // Samsung Internet
    /UCBrowser/i, // UC Browser
    /QQBrowser/i, // QQ Browser
    /YaBrowser/i, // Yandex Browser
    /Baidu/i, // Baidu Browser
    /TorBrowser|Tor/i, // Tor Browser (or Tor client in user agent)
    /Puffin/i, // Puffin browser
    /CocCoc/i, // Coc Coc browser
    /FBAV|FBAN/i, // Facebook in-app browsers
    /Instagram/i, // Instagram in-app browser
    /MiuiBrowser/i, // Xiaomi MIUI Browser
  ];
  return browserRegexes.some((regex) => regex.test(browserString));
};

export const isValidLink = (link : string) => {
  const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  return urlPattern.test(link);
};

export const isUUID = (input : string) => {
  const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidPattern.test(input);
};

export const keysToExclude = ['id', 'createdAt', 'incomeAt', 'organizationId', 'hubspotContactId', 'fsId'];
